import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

export interface BrandInsightDetails {
  wins: string[];
  losses: string[];
  recommendations: string[];
}

export interface BrandInsight {
  id: string;
  periodStart: string;
  periodEnd: string;
  summary: string;
  details: BrandInsightDetails;
  createdAt: string;
}

export function useInsights(brandId: string, limit = 12) {
  return useQuery({
    queryKey: ["insights", brandId, limit],
    queryFn: () => apiFetch<BrandInsight[]>(`/brands/${brandId}/insights?limit=${limit}`),
    enabled: !!brandId,
  });
}
